<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-if="element.id !== undefined"
          label="ID"
          v-model="element.id"
          disabled
        >
        </v-text-field>

        <v-text-field
          label="Name"
          v-model="element.name"
          :rules="requiredRules"
          required
        >
        </v-text-field>

        <v-menu
          ref="menuLastUpdate"
          v-model="menuLastUpdate"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="element.last_update"
              label="Last update"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="requiredRules"
              required
            ></v-text-field>
          </template>
          <v-date-picker v-model="element.last_update" no-title scrollable>
          </v-date-picker>
        </v-menu>

        <v-select
          label="Category"
          v-model="element.categoryId"
          :items="listCategories"
          :rules="requiredNumberRules"
          item-text="name"
          item-value="id"
          required
        >
        </v-select>

        <div
          class="previous"
          v-for="(entity, index) in element.entities"
          v-bind:key="index"
        >
          <EntityComponent
            :entity="entity"
            :all="element.entities"
            :index="index"
          >
          </EntityComponent>
        </div>

        <v-layout justify-end>
          <v-btn justify-end @click="add" color="primary">Add Entity</v-btn>
        </v-layout>

        <v-btn @click="submit" color="primary">Submit</v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import EntityComponent from './entity-component.vue';
import { EntityModel } from '../../store/law-module';

export default {
  props: ['element', 'onSubmit'],
  components: {
    EntityComponent,
  },
  data() {
    return {
      valid: true,
      menuLastUpdate: false,
      requiredRules: [
        (element) => {
          if (element.trim() === '') return 'The field is required';
          return true;
        },
      ],
      requiredNumberRules: [
        (element) => {
          if (element === 0) return 'The field is required';
          return true;
        },
      ],
    };
  },
  created() {
    this.$store.dispatch('category/getCategories', {
      appId: this.$route.params.appId,
    });
  },
  computed: {
    listCategories() {
      return this.$store.state.category.categories;
    },
  },
  methods: {
    add() {
      this.element.entities.push({ ...EntityModel });
    },

    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
